import Pointer from './pointer';

export function add({operation}) {
	console.log('add::ignoring path: ' + operation.path);
}

export function remove({operation}) {
	console.log('remove::ignoring path: ' + operation.path);
}

export function replace({identifiedFeatures, geojsonFormat, operation}) {
	const pointer = Pointer.fromJSON(operation.path);

	if (pointer.toArray()[1] === 'features') {
		const featureId = pointer.toArray()[2].slice(1);

		const feature = identifiedFeatures[featureId];
		if (!feature) {
			console.log(
				'replace::ignoring path: ' +
					operation.path +
					'. feature [' +
					featureId +
					'] does not exists.'
			);
			return;
		}

		if (pointer.toArray()[3] === 'geometry') {
			feature.setGeometry(geojsonFormat.readGeometry(operation.value));
			return;
		}
		if (pointer.toArray()[3] === 'properties') {
			feature.setProperties(operation.value); // does not trigger change
			feature.changed();
			return;
		}
	}
	console.log('replace::ignoring path: ' + operation.path);
}

export function removeUnidentifiableFromCollection({
	vectorSource,
	unidentifiedFeatures,
}) {
	unidentifiedFeatures.forEach((feature) =>
		vectorSource.removeFeature(feature)
	);
}

export function addToCollection({operation, vectorSource, geojsonFormat}) {
	vectorSource.addFeature(geojsonFormat.readFeature(operation.item));
}

export function removeFromCollection({
	operation,
	vectorSource,
	identifiedFeatures,
}) {
	if (!identifiedFeatures[operation.item.id]) {
		console.log(
			'removeFromCollection::cannot remove feature. feature [' +
				operation.item.id +
				'] does not exists.'
		);
		return;
	}

	vectorSource.removeFeature(identifiedFeatures[operation.item.id]);
}
